import * as z from "zod";

export const getCurrentPoints = {
  name: "getCurrentPoints" as const,
  input: z.object({}),
  output: z.object({ currentBalance: z.number().int() }),
};
